<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" class="text-h6 pt-4" >
      <v-card>
        <v-data-iterator  :items="appNotifications"
                          :options.sync="pagination"
                          :footer-props="{
                            'items-per-page-text': `${$t('general.notifications')} ${$t('general.perPage')}`,
                            'items-per-page-options': [50, 100, 200]
                          }"
                         :server-items-length="totalAppNotifications">
          <template v-slot:item="props">
            <Notification :notification="props.item"></Notification>
            <v-divider></v-divider>
          </template>

          <template #no-data>
            <v-row class="py-12"
                      v-if="loadingAppNotifications"
                      justify="center">
              <v-progress-circular color="kbDarkBlue"
                                   indeterminate>
              </v-progress-circular>
            </v-row>
          </template>

          <template #no-results>
            <v-row class="py-12"
                      justify="center"
                      align="center">
              <v-icon color="kbDarkBlue" left large>check</v-icon>
              {{ $t('general.youDontHaveNotifications') }}
            </v-row>
          </template>
        </v-data-iterator>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import Notification from '@/components/widgets/list/Notification.vue'
export default {
  components: { Notification },
  computed: {
    ...mapState({
      loadingAppNotifications: state => state.appNotifications.loadingAppNotifications,
      paginationAppNotifications: state => state.appNotifications.paginationAppNotifications,
      totalAppNotifications: state => state.appNotifications.totalAppNotifications,
      appNotifications: state => state.appNotifications.appNotifications
    })
  },
  data () {
    return {
      pagination: {}
    }
  },
  methods: {
    getNotifications () {
      this.$store.commit('SET_PAGINATION_APP_NOTIFICATIONS', this.pagination)
      this.$store.dispatch('getAppNotifications')
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getNotifications()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    selectedApp (value) {
      this.$store.dispatch('getNotifications')
    }
  }
}
</script>
